import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import IdInputSection from './IdInputSection';
import PasswordInputSection from './PasswordInputSection';
import JoinPathSection from './JoinPathSection';
import { SignupFormContainer, SubmitButton, FormTitle, SignupSection, SignupText } from './style';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config/URL/URL';
import PageTransition from '../atoms/PageTransition';
import AnimatedButton from '../atoms/AnimatedButton';

const SignupForm = () => {
    // 상태 관리
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [joinPath, setJoinPath] = useState('');
    const [joinPathEtc, setJoinPathEtc] = useState('');
    const { isLoggedIn, loggedInUser, login, logout } = useAuth();

    // 유효성 검사 및 메시지 상태
    // const [isValidId, setIsValidId] = useState(false);
    const [isIdChecked, setIsIdChecked] = useState(false);
    const [idMessage, setIdMessage] = useState('');
    const [passwordMessage, setPasswordMessage] = useState('');
    const [confirmPasswordMessage, setConfirmPasswordMessage] = useState('');
    const [joinPathMessage, setJoinPathMessage] = useState('');

    const navigate = useNavigate();

    // 아이디 중복 확인
    const handleIdCheck = async () => {
        if (!userId) {
            setIdMessage('아이디를 입력해주세요.');
            return;
        }

        // if (userId.length < 5 || userId.length > 15) {
        //     alert('아이디는 5자 이상 15자 이내로 입력해주세요.');
        //     return;
        // }

        try {
            const response = await axios.get(`${API_URL}/user/checkId/${userId}`);
            // const response = await axios.get(`http://localhost:8080/user/checkId/${userId}`);
            if (response.data.isAvailable) {
                setIdMessage('사용 가능한 아이디입니다.');
                setIsIdChecked(true);
            } else {
                setIdMessage('이미 사용 중인 아이디입니다.');
                setIsIdChecked(false);
            }
        } catch (error) {
            console.error('아이디 중복 확인 에러:', error);
            setIdMessage('오류가 발생했습니다. 다시 시도해주세요.');
            setIsIdChecked(false);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!isIdChecked) {
            alert('아이디 중복 확인을 해주세요.');
            return;
        }
        
        if (password.length < 8 || password.length > 16) {
            alert('비밀번호 길이를 확인해주세요.');
            return;
        }

        if (password !== confirmPassword) {
            alert('비밀번호가 일치하지 않습니다.');
            return;
        }

        // 가입경로 선택 여부 확인
        if (joinPath === '') {
            alert('가입 경로를 선택해주세요.');
            setJoinPathMessage('가입 경로를 선택해주세요.');
            return;
        }

        const signupData = {
            userId,
            password,
            joinPath,
            joinPathEtc: joinPath === '기타' ? joinPathEtc : null,
        };

        try {
            // const response = await axios.post(`${API_URL}/user/signup`, signupData);
            // const response = await axios.post('http://localhost:8080/user/signup', signupData);
            alert('회원가입 준비중입니다.');
            navigate('/');
        } catch (error) {
            console.error('회원가입 에러:', error);
            alert('회원가입에 실패했습니다. 다시 시도해주세요.');
        }
    };

    if (isLoggedIn) {
        // return (
        //     <PageTransition variant="fade">
        //         <div>
        //             <h2>{loggedInUser}님, 환영합니다!</h2>
        //             <button onClick={() => navigate('/home')}>홈으로 이동</button>
        //             <button onClick={logout}>로그아웃</button>
        //         </div>
        //     </PageTransition>
        // );
        navigate("/");
    }

    return (
        <PageTransition variant="fade">
            <SignupFormContainer onSubmit={handleSubmit}>
                <FormTitle>회원가입</FormTitle>

                <IdInputSection
                    userId={userId}
                    setUserId={setUserId}
                    isIdChecked={isIdChecked}
                    setIsIdChecked={setIsIdChecked}
                    idMessage={idMessage}
                    setIdMessage={setIdMessage}
                    onIdCheck={handleIdCheck}
                />

                <PasswordInputSection
                    password={password}
                    setPassword={setPassword}
                    confirmPassword={confirmPassword}
                    setConfirmPassword={setConfirmPassword}
                    passwordMessage={passwordMessage}
                    setPasswordMessage={setPasswordMessage}
                    confirmPasswordMessage={confirmPasswordMessage}
                    setConfirmPasswordMessage={setConfirmPasswordMessage}
                />

                <JoinPathSection
                    joinPath={joinPath}
                    setJoinPath={setJoinPath}
                    joinPathEtc={joinPathEtc}
                    setJoinPathEtc={setJoinPathEtc}
                    joinPathMessage={joinPathMessage}
                    setJoinPathMessage={setJoinPathMessage}
                />

                <SubmitButton type="submit">가입하기</SubmitButton>

                <SignupSection>
                    <SignupText>이미 계정이 있으신가요?</SignupText>
                    <AnimatedButton
                        type="button"
                        onClick={() => navigate('/user/login')}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#002755',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontSize: '14px',
                            padding: '5px 10px',
                        }}
                    >
                        로그인
                    </AnimatedButton>
                </SignupSection>
            </SignupFormContainer>
        </PageTransition>
    );
};

export default SignupForm;
